import script from "./MainMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainMenu.vue?vue&type=script&lang=ts&setup=true"

import "./MainMenu.vue?vue&type=style&index=0&id=51bbf93e&lang=css"

const __exports__ = script;

export default __exports__